import { render, staticRenderFns } from "./ReadingTimeDistributionCard.vue?vue&type=template&id=7055a3a0&scoped=true"
import script from "./ReadingTimeDistributionCard.vue?vue&type=script&lang=js"
export * from "./ReadingTimeDistributionCard.vue?vue&type=script&lang=js"
import style0 from "./ReadingTimeDistributionCard.vue?vue&type=style&index=0&id=7055a3a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7055a3a0",
  null
  
)

export default component.exports